import { contestConstants } from '../constants';

// The initial application state
let initialState = {
    formState: {
        name: '',
        email: '',
        phone: '',
        body: '',
    },
    error: '',
    sended: false,
    sending: false,
    legalTerms: false,
}

// Takes care of changing the application state
export function contest(state = initialState, action) {
    switch (action.type) {
        case contestConstants.CONTEST_FORM_CLEAR:
            return { ...state, formState: initialState.formState }
        case contestConstants.CONTEST_SEND_SUCCESS:
            return { ...state, sended: action.sended }
        case contestConstants.CONTEST_SENDING_REQUEST:
            return { ...state, currentlySending: action.sending }
        case contestConstants.CONTEST_SEND_FAILURE:
            return { ...state, error: action.error, sended: action.sended }
        case contestConstants.CONTEST_CLEAR_ERROR:
            return { ...state, error: '' }
        case contestConstants.CONTEST_CLEAR_STATE:
            state = initialState
            return state
        default:
            return state
    }
}

export default contest